export const ASSETS = {
  logo: "https://customer-assets-rejwkqb3.emergentagent.net/job_958e13ae-a825-41e7-8bb1-7bb8f57a104a/artifacts/nldl4x1b_WhatsApp%20Image%202026-08-14%20at%2010.24.37%20PM.jpeg",
  paul: "https://customer-assets-rejwkqb3.emergentagent.net/job_958e13ae-a825-41e7-8bb1-7bb8f57a104a/artifacts/kemz4pzd_Paul.jpeg",
};

export const CONTACT = {
  phone: "516-886-6002",
  phoneHref: "tel:+15168866002",
  email: "Legacycustomhomes1@gmail.com",
  emailHref: "mailto:Legacycustomhomes1@gmail.com",
  instagram: "@legacycustomhomesny",
  instagramHref: "https://instagram.com/legacycustomhomesny",
  area: "Nassau & Suffolk County, Long Island, New York",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Our Story", href: "#story" },
  { label: "Projects", href: "#projects" },
  { label: "Services", href: "#services" },
  { label: "Contact", href: "#contact" },
];

export const HERO = {
  image:
    "https://images.unsplash.com/photo-1757356657991-c3fd6e2e812e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBtb2Rlcm4lMjBob3VzZSUyMGV4dGVyaW9yJTIwc3Vuc2V0fGVufDB8fHx8MTc5MDAxNzM2OHww&ixlib=rb-4.1.0&q=85",
  headline: "Built for the Way You Live.",
  sub: "Custom home construction and complete home renovations designed with craftsmanship, attention to detail, and your vision at the center.",
};

export const SERVICES = [
  {
    title: "Custom Home Construction",
    description:
      "Ground-up residential construction designed around the homeowner's vision, lifestyle, and property.",
    image:
      "https://images.unsplash.com/photo-1599777560450-e462cffc5368?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBob3VzZSUyMGV4dGVyaW9yJTIwc3Vuc2V0fGVufDB8fHx8MTc5MDAxNzM2OHww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Complete Home Renovations",
    description:
      "Major interior and exterior transformations, including full-home remodeling and modernization.",
    image:
      "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBraXRjaGVuJTIwcmVub3ZhdGlvbnxlbnwwfHx8fDE3OTAwMTczNjh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Home Additions & Extensions",
    description:
      "Expanding existing homes with thoughtfully designed new living spaces.",
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "Interior Renovations",
    description:
      "Living rooms, bedrooms, kitchens, bathrooms, basements, flooring, millwork, and complete interior transformations.",
    image:
      "https://images.unsplash.com/photo-1705326701287-346fc37a2c86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBsaXZpbmclMjByb29tJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzkwMDE3MzY4fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Exterior Renovations",
    description:
      "Exterior remodeling, siding, roofing, entrances, decks, outdoor living spaces, and overall exterior transformations.",
    image:
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1200&q=80",
  },
];

export const CURRENT_PROJECTS = [
  {
    name: "Long Island Custom Residence",
    location: "Long Island, NY",
    type: "New Construction",
    status: "In Progress",
    description:
      "A ground-up custom residence currently under construction, featuring modern architecture, open living spaces, custom finishes, and thoughtful details throughout.",
    image:
      "https://images.unsplash.com/photo-1587582423116-ec07293f0395?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxob21lJTIwY29uc3RydWN0aW9uJTIwZnJhbWluZ3xlbnwwfHx8fDE3OTAwMTczNjh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "North Shore Home Transformation",
    location: "Nassau County, NY",
    type: "Complete Renovation",
    status: "In Progress",
    description:
      "A full-home renovation in progress — reimagined interiors, modernized systems, and a refined exterior taking shape room by room.",
    image:
      "https://images.pexels.com/photos/37627682/pexels-photo-37627682.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Suffolk County Family Addition",
    location: "Suffolk County, NY",
    type: "Home Addition",
    status: "In Progress",
    description:
      "A thoughtfully designed new living space that extends the home while honoring its original character and craftsmanship.",
    image:
      "https://images.unsplash.com/photo-1676802540678-2dceb1820113?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxob21lJTIwY29uc3RydWN0aW9uJTIwZnJhbWluZ3xlbnwwfHx8fDE3OTAwMTczNjh8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const PORTFOLIO_CATEGORIES = [
  "All",
  "New Construction",
  "Full Renovation",
  "Addition",
  "Interior",
  "Exterior",
];

export const PORTFOLIO = [
  {
    title: "Modern Estate",
    location: "Long Island, NY",
    category: "New Construction",
    image:
      "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=1400&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=80",
    ],
  },
  {
    title: "Complete Home Transformation",
    location: "Long Island, NY",
    category: "Full Renovation",
    image:
      "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBsaXZpbmclMjByb29tJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzkwMDE3MzY4fDA&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBsaXZpbmclMjByb29tJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzkwMDE3MzY4fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=1600&q=80",
    ],
  },
  {
    title: "Gourmet Kitchen Renewal",
    location: "Nassau County, NY",
    category: "Interior",
    image:
      "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBraXRjaGVuJTIwcmVub3ZhdGlvbnxlbnwwfHx8fDE3OTAwMTczNjh8MA&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBraXRjaGVuJTIwcmVub3ZhdGlvbnxlbnwwfHx8fDE3OTAwMTczNjh8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?crop=entropy&cs=srgb&fm=jpg&q=85",
    ],
  },
  {
    title: "Coastal Exterior Revival",
    location: "Suffolk County, NY",
    category: "Exterior",
    image:
      "https://images.unsplash.com/photo-1558661091-5cc1b64d0dc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBob3VzZSUyMGV4dGVyaW9yJTIwc3Vuc2V0fGVufDB8fHx8MTc5MDAxNzM2OHww&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1558661091-5cc1b64d0dc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBob3VzZSUyMGV4dGVyaW9yJTIwc3Vuc2V0fGVufDB8fHx8MTc5MDAxNzM2OHww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1600573472592-401b489a3cdc?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1600&q=80",
    ],
  },
  {
    title: "Garden-Level Addition",
    location: "Long Island, NY",
    category: "Addition",
    image:
      "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1400&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1600&q=80",
    ],
  },
  {
    title: "Twilight Poolside Residence",
    location: "Long Island, NY",
    category: "New Construction",
    image:
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1400&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=80",
    ],
  },
];

export const PROCESS_STEPS = [
  {
    number: "01",
    title: "Consultation",
    description: "Tell us what you're looking to build, renovate, or transform.",
  },
  {
    number: "02",
    title: "Planning",
    description:
      "We review the property, project goals, scope, design, and construction requirements.",
  },
  {
    number: "03",
    title: "Construction",
    description:
      "Our team brings the project to life with careful coordination and attention to detail.",
  },
  {
    number: "04",
    title: "Completion",
    description: "The finished home is delivered ready for its next chapter.",
  },
];

export const INTEREST_OPTIONS = [
  "New Custom Home",
  "Complete Home Renovation",
  "Home Addition",
  "Interior Renovation",
  "Exterior Renovation",
  "Other",
];

export const FINAL_CTA = {
  image:
    "https://images.unsplash.com/photo-1544984243-ec57ea16fe25?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBob3VzZSUyMGV4dGVyaW9yJTIwc3Vuc2V0fGVufDB8fHx8MTc5MDAxNzM2OHww&ixlib=rb-4.1.0&q=85",
};
